/* TSC logo FX — wraps each badge <img data-logo-fx> and adds the gem glow, lightning and sheen.
   Lightning is regenerated on every charge so no two strikes look alike. Pure enhancement:
   without JS the plain logo shows, exactly as before. */
(function () {
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var SVGNS = "http://www.w3.org/2000/svg";
  // the gem and the ball, in % of the square logo (measured from the source PNG)
  var GX = 48.5, GY = 24, BALL_R = 21;

  function bolt(angle, len) {
    // a jagged path from the gem outward: short segments with perpendicular jitter, the classic fork look
    var steps = 6 + Math.floor(Math.random() * 3), pts = [[GX, GY]];
    var dx = Math.cos(angle), dy = Math.sin(angle), px = -dy, py = dx;
    for (var i = 1; i <= steps; i++) {
      var t = (i / steps) * len, j = (Math.random() - 0.5) * len * 0.22;
      pts.push([GX + dx * t + px * j, GY + dy * t + py * j]);
    }
    var d = "M" + pts.map(function (p) { return p[0].toFixed(2) + " " + p[1].toFixed(2); }).join(" L");
    // an occasional fork from partway along
    if (Math.random() < 0.55) {
      var k = 2 + Math.floor(Math.random() * (steps - 3)), b = pts[k];
      var fa = angle + (Math.random() < 0.5 ? -1 : 1) * (0.5 + Math.random() * 0.4), fl = len * 0.35;
      d += " M" + b[0].toFixed(2) + " " + b[1].toFixed(2) +
           " L" + (b[0] + Math.cos(fa) * fl * 0.5 + (Math.random() - 0.5) * 2).toFixed(2) + " " + (b[1] + Math.sin(fa) * fl * 0.5).toFixed(2) +
           " L" + (b[0] + Math.cos(fa) * fl).toFixed(2) + " " + (b[1] + Math.sin(fa) * fl).toFixed(2);
    }
    return d;
  }

  function drawBolts(svg) {
    while (svg.firstChild) svg.removeChild(svg.firstChild);
    var n = 8 + Math.floor(Math.random() * 3);
    for (var i = 0; i < n; i++) {
      // spread around the full circle, biased away from straight down (the lettering sits there)
      var a = (i / n) * Math.PI * 2 + (Math.random() - 0.5) * 0.7;
      if (Math.sin(a) > 0.85) a -= 0.9;
      var len = BALL_R * (0.75 + Math.random() * 0.55);
      var d = bolt(a, len), delay = (Math.random() * 0.6).toFixed(2) + "s", dur = (0.75 + Math.random() * 0.5).toFixed(2) + "s";
      ["glow", "core"].forEach(function (cls) {
        var p = document.createElementNS(SVGNS, "path");
        p.setAttribute("d", d); p.setAttribute("class", cls);
        p.style.setProperty("--len", Math.ceil(len * 1.6));
        p.style.setProperty("--delay", delay); p.style.setProperty("--dur", dur);
        svg.appendChild(p);
      });
    }
  }

  function enhance(img) {
    if (img.dataset.fxReady) return;
    img.dataset.fxReady = "1";
    var wrap = document.createElement("span");
    // the wrapper takes over the image's classes and inline sizing, so every existing rule
    // (including the header's responsive sizes) now sizes the wrapper, and the image just fills it
    wrap.className = "tsc-logo " + img.className + (img.getAttribute("data-logo-fx") === "small" ? " is-small" : "");
    wrap.style.cssText = img.style.cssText;
    img.removeAttribute("class"); img.style.cssText = "";
    wrap.style.setProperty("--logo-mask", 'url("' + (img.currentSrc || img.src) + '")');
    img.parentNode.insertBefore(wrap, img);
    wrap.appendChild(img);
    var halo = document.createElement("span"); halo.className = "lfx-halo";
    var gem = document.createElement("span"); gem.className = "lfx-gem";
    var svg = document.createElementNS(SVGNS, "svg");
    svg.setAttribute("class", "lfx-bolts"); svg.setAttribute("viewBox", "0 0 100 100"); svg.setAttribute("aria-hidden", "true");
    var sheen = document.createElement("span"); sheen.className = "lfx-sheen";
    var flare = document.createElement("span"); flare.className = "lfx-flare";
    [halo, gem, svg, sheen, flare].forEach(function (el) { el.setAttribute("aria-hidden", "true"); wrap.appendChild(el); });
    if (reduce) return;
    drawBolts(svg);

    // fresh lightning every time it's charged
    var host = wrap.closest("a, button") || wrap;
    host.addEventListener("pointerenter", function () { drawBolts(svg); });
    host.addEventListener("focus", function () { drawBolts(svg); }, true);

    // touch screens have no hover: charge on tap (without blocking the link) and, for the
    // big feature logos, once when they scroll into view
    var charge = function (ms) {
      drawBolts(svg); wrap.classList.add("is-charged");
      clearTimeout(wrap._t); wrap._t = setTimeout(function () { wrap.classList.remove("is-charged"); }, ms || 2200);
    };
    wrap.addEventListener("pointerdown", function (e) { if (e.pointerType !== "mouse") charge(1600); });
    if (img.getAttribute("data-logo-fx") === "feature" && "IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { charge(2600); io.disconnect(); } });
      }, { threshold: 0.6 });
      io.observe(wrap);
    }
  }

  function run() {
    Array.prototype.forEach.call(document.querySelectorAll("img[data-logo-fx]"), function (img) {
      if (img.complete && img.naturalWidth) enhance(img);
      else img.addEventListener("load", function () { enhance(img); }, { once: true });
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run); else run();
})();
